import React from 'react';

import { useBreakpoints } from '@pkg/hooks';

import { Wrapper } from './styles';

export const FiltersSidebar = ({ children }: { children: React.ReactNode }) => {
    const { isMobile } = useBreakpoints();

    const transition = !isMobile
        ? {
              initial: { width: 0 },
              animate: { width: 276 },
              exit: { width: 0 },
              transition: {
                  duration: 0.2,
                  ease: 'easeInOut',
              },
          }
        : {};

    return <Wrapper {...transition}>{children}</Wrapper>;
};
